import React from 'react'
import { Route } from 'react-router-dom'

import TalktimeMonitor from 'components/Artefacts/TalktimeMonitor'
import RoomLayoutArtefactWeb from 'components/Layouts/RoomLayoutArtefactWeb'
import Choice from 'components/Quiz/Revamp/Choice'
import EndQuizScreen from 'components/Quiz/Revamp/EndQuizScreen'
import { Correct, Incorrect, Timedout } from 'components/Quiz/Revamp/Headers'
import QuestionsLayout from 'components/Quiz/Revamp/QuestionsLayout'
import StartQuizScreen from 'components/Quiz/Revamp/StartQuizScreen'
import Student from 'components/Tiles/Student'
import Teacher from 'components/Tiles/Teacher'

import { Container, Section, DummyArtefact } from './styles'
import TestNotifications from './TestNotifications'

const count = 15
const student = (
    <Student
        isLocal
        identity={{ firstName: 'rameshswarama' }}
        studentsCount={count}
        isArtefactMode={true}
        networkQualityLevel={5}
    />
)
const teacher = size => (
    <Teacher
        identity={{ firstName: 'teacher' }}
        size={size}
        studentsCount={count}
        isArtefactMode={true}
        networkQualityLevel={5}
    />
)
const students = new Array(count).fill(student)
const layoutProps = {
    students,
    teacher: teacher('s'),
    artefact: <DummyArtefact />,
}

/** This component is used for developing and testing the different room modes
   and layouts without any api calls or twilio stuffs. */

const UI = ({ match }) => {
    // const [ttData, addTTData, rmTTData] = useTTData()
    return (
        <Container>
            <Section className="main">
                <Route exact path={match.url + '/test'}>
                    <TestNotifications />
                </Route>
                <Route exact path={match.url + '/start-quiz-screen'}>
                    <StartQuizScreen />
                </Route>
                <Route exact path={match.url + '/quiz'}>
                    <div
                        style={{
                            borderRadius: '10px',
                            background: 'white',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            width: '100vw',
                            height: '100vh',
                            padding: '20px',
                        }}
                    ></div>
                </Route>
                <Route exact path={match.url + '/end-quiz-screen'}>
                    <EndQuizScreen />
                </Route>
                <Route exact path={match.url + '/questions-screen'}>
                    <QuestionsLayout />
                </Route>
                <Route exact path={match.url + '/layout/artefact'}>
                    <div
                        style={{
                            width: '100vw',
                            height: '100vh',
                        }}
                    >
                        <RoomLayoutArtefactWeb {...layoutProps} />
                    </div>
                </Route>
                <Route exact path={match.url + '/ttm'}>
                    <TalktimeMonitor />
                </Route>
            </Section>
        </Container>
    )
}

export default UI
